export const config = {
  BASE_API: process.env.REACT_APP_API,
};
